import { useState } from 'react';
import styles from './style.module.scss';
import { VolumeIcon } from 'src/onboarding/assets/icons/VolumeIcon';
import { PhoneDownIcon } from 'src/onboarding/assets/icons/PhoneDownIcon';
import { MicrophoneOffIcon } from 'src/onboarding/assets/icons/MicrophoneOffIcon';
import { PhoneVolumeIcon } from 'src/onboarding/assets/icons/PhoneVolumeIcon';

export default function CallControlBar({
  theme = 'dark',
  callActive = true,
  muted = false,
  speaker = false,
  onEndCall,
  onToggleMute,
  onToggleSpeaker,
}) {
  const isDark = theme === 'dark';

  const barClass = [
    styles.bar,
    isDark ? styles.barDark : styles.barLight,
  ].join(' ');

  const speakerClass = [
    styles.btn,
    speaker 
      ? (isDark ? styles.btnSpeakerDark : styles.btnSpeakerLight)
      : styles.btnSpeakerOff,
  ].join(' ');

  const endCallClass = [
    styles.btn,
    callActive ? styles.btnEndCallActive : styles.btnEndCallInactive,
  ].join(' ');

  const muteClass = [
    styles.btn,
    muted
      ? isDark ? styles.btnMutedDark : styles.btnMutedLight
      : styles.btnUnmuted,
  ].join(' ');

  return (
    <div className={barClass}>
      <button
        className={speakerClass}
        onClick={onToggleSpeaker}
        aria-label="Toggle speaker"
      >
        <PhoneVolumeIcon />
      </button>

      <button
        className={endCallClass}
        onClick={callActive ? onEndCall : undefined}
        disabled={!callActive}
        aria-label={callActive ? 'End call' : 'Call ended'}
      >
        <PhoneDownIcon/>
      </button>

      <button
        className={muteClass}
        onClick={onToggleMute}
        aria-label={muted ? 'Unmute' : 'Mute'}
      >
        <MicrophoneOffIcon />
      </button>
    </div>
  );
}
